import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'
import { getAvailableBookingProtectionBenefits } from 'luxPlus/selectors/benefits/bookingProtection'

function useLuxPlusBookingProtectionAvailableCopy() {
  const intl = useIntl()
  const luxPlusBookingProtectionBenefitView = useAppSelector(getAvailableBookingProtectionBenefits)
  if (luxPlusBookingProtectionBenefitView.isAvailable && luxPlusBookingProtectionBenefitView.totalMemberMaxSavings) {
    return intl.formatMessage(
      {
        id: 'eKv5xx35kd',
        defaultMessage: 'Save up to {discountPercentage}% on cancellation protection at checkout',
        description: 'LuxPlus booking protection benefit copy showing maximum discount percentage available at checkout',
      },
      { discountPercentage: luxPlusBookingProtectionBenefitView.luxPlusDiscountPercentage },
    )
  }
}

export default useLuxPlusBookingProtectionAvailableCopy
